import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BmarkSpotRiskTotalsRendererComponent } from "app/bfx-bmark-summary/blotters/spot-risk/renderers/bmark-spot-risk-totals-renderer.component";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BmarkFwdRiskDisplayModel } from "shared/cubiq-services/model/benchmarks/BmarkSpotRiskDisplay.model";

/**
 * Extension to Spot Risk total renderer - as Spot Totals represent the opposite risk side, we must
 * invert the intent of the order for non-zero amounts
 */
@Component({
  selector: "fwd-risk-totals",
  templateUrl: "./bmark-spot-risk-totals.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BmarkFwdRiskTotalsRendererComponent extends BmarkSpotRiskTotalsRendererComponent {
  constructor() {
    super();
  }
  protected processParams(params: any): void {
    super.processParams(params);
    if (!this.isZero && params.data instanceof BmarkFwdRiskDisplayModel) {
      const fwdModel: BmarkFwdRiskDisplayModel = params.data;
      if (fwdModel.getTenor() === CubiqTS.Tenor.SPOT) {
        this.isNegative = !this.isNegative;
      }
    }
  }

  /**
   *  Need to negate all amounts for spot
   * @param value
   * @param displayZero
   * @returns
   */
  public override formatAmt(value: CubiqTS.BigNumber, displayZero: boolean, params: any): string {
    const fwdModel: BmarkFwdRiskDisplayModel = params.data;
    if (fwdModel.getTenor() === CubiqTS.Tenor.SPOT) {
      if (value instanceof CubiqTS.BigNumber && !value.isZero()) {
        return super.formatAmt(value.negated(), displayZero, params);
      }
    }
    return super.formatAmt(value, displayZero, params);
  }
}
